import React from "react";
import { FormControl, TextField } from "@mui/material";

const FormTextArea = ({
  id,
  value="",
  onChange,
  label,
  placeholder = "Enter text...",
  disabled = false,
  required = false,
  minRows = 3,
  maxRows = 6,
}) => {

  return (
    <FormControl
      fullWidth
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TextField
        id={id}
        value={value ?? ''} 
        onChange={onChange}
        placeholder={placeholder}
        multiline
        minRows={minRows}
        maxRows={maxRows}
        disabled={disabled}
        required={required}
        sx={{
          fontSize: "1rem",
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
        }}
        InputProps={{
            sx: {
            borderColor: "var(--gray-300)",
            padding: '13px',
            '& fieldset': {
              borderColor: 'var(--gray-300)',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'var(--navyBlue-default) !important',
            },
            '&.Mui-disabled': {
              backgroundColor: 'var(--gray-100)',
              color: 'var(--gray-300)',
              cursor: 'not-allowed',
              '& fieldset': {
                borderColor: 'var(--gray-300) !important',
              },
            },
            }

        }}
      />
    </FormControl>
  );
};

export default FormTextArea;

